import { render, staticRenderFns } from "./ProductEditForm.vue?vue&type=template&id=4e9fe554&"
import script from "./ProductEditForm.vue?vue&type=script&lang=js&"
export * from "./ProductEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports